export const STATEMENT_MAX_LENGTH = 1000;
export const NAME_MAX_LENGTH = 50;
export const TITLE_MAX_LENGTH = 100;
